import { Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { QuickLoanService } from "src/app/_QuickLoan/services/quickLoan.service";
import { DataSharingService } from "../../../AuthGuard/DataSharingService";
import { MasterService } from "../../../Shared/app.Masters.Service";
import { SnackbarComponent } from "../../../snackbar/snackbar.component";
import { ReportsService } from "../../services/reports.service";
declare var $: any;

@Component({
  selector: "app-rbi_dnb2-report",
  templateUrl: "./rbi_dnb2-report.component.html",
  styleUrls: ["./rbi_dnb2-report.component.scss"],
})
export class RBIDNB2ReportComponent implements OnInit {
  showSpinner: boolean;
  currentUser: any;
  SlabData: any[] = [];
  ToDate: any = new Date();
  FromDate: any;
  SlabId: any = "";
  DataSource: any;
  DataSourceDetail: any;
  modalTitle: string;
  selectedId: any;

  displayedColumns: string[] = [
    "Id",
    "Product_Name",
    "Before_Exposer_PrincipalCount",
    "Before_Exposer_Principal",
    "Before_STDCount",
    "Before_STD",
    "Before_NPACount",
    "Before_NPA",
    "addtionCount",
    "addtion",
    "Up_gradationCount",
    "Up_gradation",
    "RecoveryCount",
    "Recovery",
    "WrittenOffCount",
    "WrittenOff",
    "After_NPACount",
    "After_NPAsum",
    "After_STD",
    "SubStandard",
    "DoubtfulAssets",
    "LossAssets",
    "After_Exposer_Principal",
  ];
  displayedColumnsDetail: string[] = [
    "Id",
    "LoanAcNo",
    "CustomerName",
    "Product_Name",
    "Branch_Name",
    "Loan_Date",
    "LoanClosed_Date",
    "Application_LoanAmount",
    "Before_Exposer_PrincipalCount",
    "Before_Exposer_Principal",
    "Before_STDCount",
    "Before_STD",
    "Before_NPACount",
    "Before_NPA",
    "addtionCount",
    "addtion",
    "Up_gradationCount",
    "Up_gradation",
    "RecoveryCount",
    "Recovery",
    "WrittenOffCount",
    "WrittenOff",
    "After_NPACount",
    "After_NPA",
    "After_STD",
    "SubStandard",
    "DoubtfulAssets",
    "LossAssets",
    "After_Exposer_Principal",
  ];
  @ViewChild("summaryPaginator") paginator: MatPaginator;
  @ViewChild("summarySort") sort: MatSort;

  @ViewChild("detailPaginator") paginatorDetail: MatPaginator;
  @ViewChild("detailSort") sortDetail: MatSort;
  // top 50
  ToDatetop50: any = new Date();
  FromDatetop50: any;
  SlabIdtop50: any = "";
  DataSourcetop50: any;
  DataSourcetop50Model: any;
  displayedColumnstop50: string[] = [
    "CustomerId",
    "NameOfBorrower",
    "CustomerType",
    "Pan_Number",
    "TotalSanctionedLoanAmount",
    "DisbursedLoanAmount",
    "UndisbursedLoanAmount",
    "TotalPrincipalOutstandingAmount",
    "TotalAccruedInterestAmount",
    "StatusofAccount",
    "AmountOutstanding",
  ];
  displayedColumnsDetailTop50: string[] = [
    "CustomerId",
    "NameOfBorrower",
    "Pan_Number",
    "CustomerType",
    "TotalSanctionedLoanAmount",
    "DisbursedLoanAmount",
    "UndisbursedLoanAmount",
    "TotalPrincipalOutstandingAmount",
    "TotalAccruedInterestAmount",
    "StatusofAccount",
    "AmountOutstanding",
  ];

  @ViewChild("top50Paginator") paginatorTop50: MatPaginator;
  @ViewChild("top50Sort") sortTop50: MatSort;

  @ViewChild("detailSortTop50") sortDetailTop50: MatSort;
  @ViewChild("detailPaginatorTop50") paginatorDetailTop50: MatPaginator;

  // NPA Report
  ToDateNPA: any = new Date();
  SlabIdNPA: any = "";
  DataSourceNPA: any;

  displayedColumnsNPA: string[] = [
    "CustomerId",
    "NameOfBorrower",
    "Pan_Number",
    "CustomerType",
    "CIN_No",
    "LoanPurpose",
    "LoanDuration_Month",
    "Product_Name",
    "TypeaOfLoan",
    "TotalSanctionedLoanAmount",
    "TotalOutstandingLoanAmount",
    "DateofLastPayment",
    "DateofFirstDefault",
    "StatusofAccount",
  ];
  @ViewChild("NpaPaginator") paginatorNPA: MatPaginator;
  @ViewChild("NpaSort") sortNPA: MatSort;

  // Branch Report
  ToDateBranch: any = new Date();
  DataSourceBranch: any;
  displayedColumnsBranch: string[] = [
    "SrNo",
    "Branch_Name",
    "BRANCH_ADDRESS",
    "DISTRICT",
    "STATE",
    "NO_OF_DEPOSIT_ACCOUNT",
    "NO_OF_LOAN_ACCOUNT",
    "OPENING_DATE",
    "Closing_DATE",
    "OUTSTANDING_LOAN",
  ];
  @ViewChild("BranchPaginator") paginatorBranch: MatPaginator;
  @ViewChild("BranchSort") sortBranch: MatSort;

  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };

  constructor(
    private dataSharingService: DataSharingService,
    private _QuickLoanService: QuickLoanService,
    private masterService: MasterService,
    private reportsService: ReportsService,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.dataSharingService.HeaderTitle.next("DNB 2 Report");
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.setDefaultDates();
    this.getSlabsList();
  }

  setDefaultDates() {
    const currentDate = new Date();
    const firstDateOfMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      1
    );
    this.FromDate = firstDateOfMonth;
    this.ToDate = currentDate;
  }

  getSlabsList() {
    this.masterService
      .Get__Slab_dropdown({ Type: "NPA", LoginUserId: this.currentUser.userId })
      .subscribe((res) => {
        this.SlabData = JSON.parse(JSON.stringify(res));
      });
  }

  onSearchDNBReport() {
    this.showSpinner = true;
    this.reportsService
      .Report_DNBS2_Portfolio_Summary({
        fromdate: this.FromDate,
        slabId: this.SlabId,
        toDate: this.ToDate,
      })
      .subscribe((res: any) => {
        this.showSpinner = false;
        this.DataSource = new MatTableDataSource(
          JSON.parse(JSON.stringify(res))
        );
        setTimeout(() => {
          this.DataSource.paginator = this.paginator;
          this.DataSource.sort = this.sort;
        });
      });
  }
  onclickDetail(row) {
    this.showSpinner = true;
    this.reportsService
      .Report_DNBS2_Portfolio_Detail({
        fromdate: this.FromDate,
        toDate: this.ToDate,
        ProductId: row.ProductId,
        slabId: this.SlabId,
      })
      .subscribe((res: any) => {
        this.showSpinner = false;
        if (res.length > 0) {
          this.DataSourceDetail = new MatTableDataSource(
            JSON.parse(JSON.stringify(res))
          );
          setTimeout(() => {
            this.DataSourceDetail.paginator = this.paginatorDetail;
            this.DataSourceDetail.sort = this.sortDetail;
          });
          this.showSpinner = false;
          this.modalTitle = "DNB 2 Report - " + row.Product_Name;
          $("#DNB2DetailModal").modal("show");
          $("#DNB2DetailModal").css("z-index", "1050");
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No data found",
            ...this.configSuccess,
          });
          this.showSpinner = false;
        }
      });
  }
  closeModal() {
    $("#DNB2DetailModal").modal("hide");
    $("#Top50DetailModal").modal("hide");
  }

  getTotal(column: string): number {
    return (
      this.DataSourceDetail?.data
        ?.map((t: any) => Number(t[column]) || 0)
        ?.reduce((acc: number, value: number) => acc + value, 0) || 0
    );
  }
  getTotalSummary(column: string): number {
    return (
      this.DataSource?.data
        ?.map((t: any) => Number(t[column]) || 0)
        ?.reduce((acc: number, value: number) => acc + value, 0) || 0
    );
  }

  exportTable(exporter: any) {
    exporter.exportTable("xls", {
      fileName: `Dnb2 ${this.modalTitle} Detail  Report`,
      sheet: "Scheme",
    });
  }
  exportTable1(exporter: any) {
    exporter.exportTable("xls", {
      fileName: `DNB 2 Report`,
      sheet: "Scheme",
    });
  }
  // top 50
  onSearchTop50() {
    this.showSpinner = true;
    this.reportsService
      .Report_DNBS2_Top_Borrower_Summary({
        slabId: this.SlabIdtop50,
        toDate: this.ToDatetop50,
      })
      .subscribe((res: any) => {
        this.showSpinner = false;
        this.DataSourcetop50 = new MatTableDataSource(
          JSON.parse(JSON.stringify(res))
        );
        setTimeout(() => {
          this.DataSourcetop50.paginator = this.paginatorTop50;
          this.DataSourcetop50.sort = this.sortTop50;
        });
      });
  }
  onclickDetailTop50(row) {
    this.showSpinner = true;
    this.reportsService
      .Report_DNBS2_Top_Borrower_Detail({
        toDate: this.ToDatetop50,
        customerId: row.CustomerId,
        slabId: this.SlabIdtop50,
      })
      .subscribe((res: any) => {
        this.showSpinner = false;
        if (res.length > 0) {
          this.DataSourcetop50Model = new MatTableDataSource(
            JSON.parse(JSON.stringify(res))
          );
          setTimeout(() => {
            this.DataSourcetop50Model.paginator = this.paginatorDetailTop50;
            this.DataSourcetop50Model.sort = this.sortDetailTop50;
          });
          this.showSpinner = false;
          this.modalTitle = "Top 50 Borrower " + row.NameOfBorrower;
          $("#Top50DetailModal").modal("show");
          $("#Top50DetailModal").css("z-index", "1050");
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No data found",
            ...this.configSuccess,
          });
          this.showSpinner = false;
        }
      });
  }

  getTotalTop50(column: string): number {
    return (
      this.DataSourcetop50?.data
        ?.map((t: any) => Number(t[column]) || 0)
        ?.reduce((acc: number, value: number) => acc + value, 0) || 0
    );
  }

  getTotalDetailTop50(column: string): number {
    return (
      this.DataSourcetop50Model?.data
        ?.map((t: any) => Number(t[column]) || 0)
        ?.reduce((acc: number, value: number) => acc + value, 0) || 0
    );
  }
  exportTableTop50(exporter: any) {
    exporter.exportTable("xls", {
      fileName: `Dnb2 ${this.modalTitle} Detail  Report`,
      sheet: "Scheme",
    });
  }
  exportTableTop50Model(exporter: any) {
    exporter.exportTable("xls", {
      fileName: `DNB 2 Top 50 Report`,
      sheet: "Scheme",
    });
  }
  // NPA Report
  onSearchNpaReport() {
    this.showSpinner = true;
    this.reportsService
      .Report_DNBS2_NPA_Detail({
        toDate: this.ToDateNPA,
        slabId: this.SlabIdNPA,
      })
      .subscribe((res: any) => {
        this.showSpinner = false;
        this.DataSourceNPA = new MatTableDataSource(
          JSON.parse(JSON.stringify(res))
        );
        setTimeout(() => {
          this.DataSourceNPA.paginator = this.paginatorNPA;
          this.DataSourceNPA.sort = this.sortNPA;
        });
      });
  }

  getTotalNPA(column: string): number {
    return (
      this.DataSourceNPA?.data
        ?.map((t: any) => Number(t[column]) || 0)
        ?.reduce((acc: number, value: number) => acc + value, 0) || 0
    );
  }
  exportTableNPA(exporter: any) {
    exporter.exportTable("xlsx", { fileName: "NPA_Report" });
  }
  // branch report
  onSearchBranchReport() {
    this.showSpinner = true;
    this.reportsService
      .Report_DNBS2_NPA_Branch_Detail({
        toDate: this.ToDateBranch,
      })
      .subscribe((res: any) => {
        this.showSpinner = false;
        this.DataSourceBranch = new MatTableDataSource(
          JSON.parse(JSON.stringify(res))
        );
        setTimeout(() => {
          this.DataSourceBranch.paginator = this.paginatorBranch;
          this.DataSourceBranch.sort = this.sortBranch;
        });
      });
  }

  getTotalBranch(column: string): number {
    return (
      this.DataSourceBranch?.data
        ?.map((t: any) => Number(t[column]) || 0)
        ?.reduce((acc: number, value: number) => acc + value, 0) || 0
    );
  }
  exportTableBranch(exporter: any) {
    exporter.exportTable("xlsx", { fileName: "Branch_Report" });
  }

  // Common Function
  applyFilter(filterValue: string) {
    const filter = filterValue.trim().toLowerCase();

    const dataSources = [
      this.DataSource,
      this.DataSourceDetail,
      this.DataSourcetop50,
      this.DataSourcetop50Model,
      this.DataSourceNPA,
      this.DataSourceBranch,
    ];

    dataSources.forEach((ds) => {
      if (ds instanceof MatTableDataSource) {
        ds.filter = filter;
      }
    });
  }
}
